<template>
    <v-container fluid grid-list-xl class="pt-0">
        <v-layout align-center wrap id="printCurso">
            <v-flex pt-0>
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>
                            <v-icon>fa fa-eye</v-icon>
                            Detalles del Curso
                        </v-toolbar-title>
                        <v-divider class="mx-2" inset vertical></v-divider>

                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-btn icon @click="printCurso">
                                <v-icon>fa-print</v-icon>
                            </v-btn>
                            <v-btn icon @click="cancelForm()">
                                <v-icon>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-container fluid grid-list-xl class="px-1 py-1">
                            <v-layout align-center wrap>
                                <v-flex xs12 sm5 pl-0>
                                    <h4 class="headline mb-2 text-xs-center">
                                        estudiante fulanito de tal
<!--                                        ToDo: falta la relacion de estudiante en el back-->
                                    </h4>
                                    <div class="blue--text text-xs-center mb-2">
                                        Primer pago: {{ detailsItem.mes ? mesesItem[detailsItem.mes - 1].nombre : "-" }}
                                    </div>
                                    <div
                                        :class="
                                            detailsItem.estado === 1
                                                ? 'green--text subheading font-weight-bold text-xs-center pb-2'
                                                : 'grey--text subheading font-weight-bold text-xs-center pb-2'
                                        "
                                    >
                                        {{ detailsItem.status_description }}
                                    </div>
                                    <div class="text-xs-center pt-3">
                                        <v-btn
                                            flat
                                            small
                                            round
                                            outline
                                            color="orange"
                                            :disabled="loading"
                                            @click="openForm(detailsItem)"
                                        >
                                            Editar
                                        </v-btn>
                                        <v-btn
                                            flat
                                            small
                                            round
                                            outline
                                            color="orange"
                                            :disabled="loading"
                                            @click="deleteItem(detailsItem)"
                                        >
                                            {{ deleteCursoConfirm ? "Confirmar" : "Eliminar" }}
                                        </v-btn>
                                    </div>
                                </v-flex>

                                <v-flex sm7>
                                    <v-container fluid grid-list-xl class="px-1 py-0">
                                        <v-layout align-center wrap>
                                            <v-divider inset vertical></v-divider>
                                            <v-layout tag="v-card-text" text-xs-left wrap>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2
                                                    >Tipo de financiamiento:</v-flex
                                                >
                                                <v-flex sm5>{{
                                                    detailsItem.financiamiento_tipo
                                                        ? detailsItem.financiamiento_tipo.nombre
                                                        : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Tarifa:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.tarifa ? detailsItem.tarifa.nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Grado:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.grado ? detailsItem.grado[0].nombre : "-"
                                                }}</v-flex>
                                                <v-flex tag="strong" sm6 text-xs-right mr-2>Grupo:</v-flex>
                                                <v-flex sm5>{{
                                                    detailsItem.grupo ? detailsItem.grupo.letra : "-"
                                                }}</v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-flex sm12>
                                    <v-divider></v-divider>
                                    <v-container fluid grid-list-xl class="px-1 py-1">
                                        <v-layout align-center wrap>
                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Campus:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.campus ? detailsItem.campus.nombre : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Sección:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.seccion ? detailsItem.seccion.nombre : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap class="px-1 pb-0">
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Colegiatura:</v-flex
                                                            >
                                                            <v-flex sm5>MX {{ detailsItem.colegiatura_base }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Descuento:</v-flex
                                                            >
                                                            <v-flex sm5>{{ detailsItem.colegiatura_descuento }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2>Beca:</v-flex>
                                                            <v-flex sm5>{{
                                                                detailsItem.beca ? detailsItem.beca : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                        <v-divider inset vertical></v-divider>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>

                                            <v-flex sm4>
                                                <v-container fluid grid-list-xl class="px-0 pb-0 pt-2">
                                                    <v-layout align-center wrap>
                                                        <v-layout tag="v-card-text" text-xs-left wrap>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Inscripción:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.inscripcion ? detailsItem.inscripcion : "-"
                                                            }}</v-flex>
                                                            <v-flex tag="strong" sm6 text-xs-right mr-2
                                                                >Reinscripción:</v-flex
                                                            >
                                                            <v-flex sm5>{{
                                                                detailsItem.reinscripcion
                                                                    ? detailsItem.reinscripcion
                                                                    : "-"
                                                            }}</v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </v-container>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <curso-form
            v-if="showForm"
            :form-title="title"
            :initial-item="editItem"
            :estudiante-id="detailsItem.estudiante_id"
            @formCanceled="closeForm"
        >
        </curso-form>
    </v-container>
</template>

<script>
import Util from "@/util"
const CursoForm = () => import("@/components/cobranza/curso/curso-form")

export default {
    name: "EstudianteDetails",
    components: { CursoForm },
    props: {
        item: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,

            //meses
            mesesItem: Util.yearMonths(),

            title: "",
            showForm: false,
            editItem: null,

            deleteCursoConfirm: false
        }
    },
    methods: {
        cancelForm() {
            this.$emit("detailsCanceled")
        },

        openForm(item) {
            this.title = "Modificar curso"
            this.editItem = item
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(item) {
            if (this.deleteCursoConfirm) {
                this.loading = true
                this.$store.dispatch("DELETE_CURSO", item).then(() => {
                    this.loading = false
                    this.$emit("detailsCanceled")
                    this.deleteCursoConfirm = false
                })
            } else {
                this.deleteCursoConfirm = true
            }
        },

        printCurso() {
            this.$htmlToPaper("printCurso")
        }//ToDo: crear una tabla sin estilos para imprimir
    },

    computed: {
        detailsItem() {
            let curso = this.$store.getters.CURSOS.filter(el => el.id === this.item.id)[0]
            if (curso) {
                return curso
            } else return []
        }
    }
}
</script>

<style scoped></style>
